/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const DeclineButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.delete}
      iconName="clear"
      tooltip={formatMessage({ id: "common.decline" })}
      css={labellessButtonCss}
      {...props}
    />
  );
};

export default DeclineButton;
